import React, { Suspense, useEffect, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { markLabVisited } from "../utils/labs.js";

class ServiceErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <main style={{ padding: 32 }}><h1>서비스를 불러오지 못했어요.</h1><p>연결 상태를 확인하고 다시 열어주세요.</p><button onClick={() => window.location.reload()}>새로고침</button> <Link to="/lab">랩스 목록</Link></main>;
    return this.props.children;
  }
}

export default function LabServiceRoute({ service }) {
  useLayoutEffect(() => { window.scrollTo(0, 0); }, [service.id]);
  useEffect(() => { markLabVisited(service.id); }, [service.id]);
  const Component = service.Component;
  return <ServiceErrorBoundary key={service.id}><Suspense fallback={<p role="status" style={{ padding: 32 }}>서비스를 여는 중이에요…</p>}><Component /></Suspense></ServiceErrorBoundary>;
}
